<template>
  <div>
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../commons/header';
import Footer from '../commons/footers'
export default {
  components:{Header,Footer},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/smartProduct/index.vue